(function () {
  'use strict';
  var drawer = document.getElementById('mp-cart-drawer');
  if (!drawer) return;
  var root = (window.STMNBtbConfig?.root || '/').replace(/\/?$/, '/');
  var lastCart = null, open = false, closing = false, busy = false, failed = false;
  var closeTimer = null, openFrame = null, trigger = null, oldOverflow = '', inertNodes = [];
  var readTask = null, readAgain = false, revision = 0, recRevision = 0;
  var transport = window.STMNCartTransport;
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
  var money = function (cents) { return window.STMNBtb ? window.STMNBtb.money(cents) : new Intl.NumberFormat('it-IT',{style:'currency',currency:window.STMNBtbConfig?.currency||'EUR'}).format(cents/100); };
  function status(text) { $('mp-cart-status').textContent = text; }
  function count(cart) {
    document.querySelectorAll('[data-cart-count],.cart-count-bubble span:first-child').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
  }
  function syncBusy() {
    var locked = busy || failed || transport.busy;
    drawer.setAttribute('aria-busy', String(busy || transport.busy));
    drawer.querySelectorAll('[data-cart-action],#mp-cart-discount-btn,#mp-cart-discount-input').forEach(function (el) { el.disabled = locked; });
    $('mp-cart-checkout-btn').setAttribute('aria-disabled', String(locked));
    $('mp-cart-checkout-btn').tabIndex = locked ? -1 : 0;
    var offer = drawer.querySelector('[data-stmn-chalk-live]');
    if (offer) offer.inert = locked;
    $('mp-cart-error').querySelector('button').disabled = busy;
  }
  function showError(message, stale) {
    failed = !!stale;
    $('mp-cart-error-text').textContent = message;
    $('mp-cart-error').hidden = false;
    syncBusy();
    if (open) $('mp-cart-scroll').scrollTop = 0;
  }
  function clearError() { failed = false; $('mp-cart-error').hidden = true; }
  function focusables() {
    return Array.from(drawer.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex]')).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length;
    });
  }
  function restoreBackground() {
    document.body.classList.remove('stmn-cart-open');
    document.body.style.overflow = oldOverflow;
    inertNodes.forEach(function (entry) { entry.el.inert = entry.was; });
    inertNodes = [];
  }
  window.mpCartDrawerOpen = function () {
    clearTimeout(closeTimer); cancelAnimationFrame(openFrame);
    if (!open && !closing) {
      trigger = document.activeElement;
      oldOverflow = document.body.style.overflow;
      Array.from(document.body.children).forEach(function (el) {
        if (el === drawer || el.id === 'mp-cart-overlay' || /^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) return;
        inertNodes.push({el:el,was:el.inert}); el.inert = true;
      });
    }
    open = true; closing = false;
    $('mp-cart-overlay').hidden = false; drawer.hidden = false;
    document.body.classList.add('stmn-cart-open');
    document.body.style.overflow = 'hidden';
    openFrame = requestAnimationFrame(function () { if (open) { drawer.classList.add('is-open'); $('mp-cart-close').focus({preventScroll:true}); } });
    window.mpCartDrawerRefresh();
  };
  window.mpCartDrawerClose = function (afterClose) {
    if (!open && !closing) return;
    open = false; closing = true;
    cancelAnimationFrame(openFrame); clearTimeout(closeTimer);
    drawer.classList.remove('is-open');
    closeTimer = setTimeout(function () {
      if (open) return;
      drawer.hidden = true; $('mp-cart-overlay').hidden = true; closing = false;
      restoreBackground();
      if (trigger?.isConnected && !trigger.closest('[inert]') && trigger.getClientRects().length) trigger.focus({preventScroll:true});
      else document.querySelector('.site-header__icon-btn[aria-label="Carrello"]')?.focus({preventScroll:true});
      if (typeof afterClose === 'function') afterClose();
    }, matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 300);
  };
  function priceHTML(item) {
    var old = item.original_line_price || 0, now = item.final_line_price || 0;
    return '<div class="mp-cart-item__prices">'+(old > now ? '<s>'+money(old)+'</s>' : '')+'<strong>'+money(now)+'</strong></div>';
  }
  function itemHTML(item) {
    var title = esc(item.product_title), notes = [];
    if (item.stmn_offer_note) notes.push(item.stmn_offer_note);
    (item.discounts || []).forEach(function (d) { if (d.title) notes.push(d.title); });
    (item.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application?.title) notes.push(a.discount_application.title); });
    notes = Array.from(new Set(notes));
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="mp-cart-item__variant">'+esc(item.variant_title)+'</p>' : '';
    var badge = notes.length ? '<div class="mp-cart-item__badges">'+notes.map(function (s) { return '<span>'+esc(s)+'</span>'; }).join('')+'</div>' : '';
    return '<article class="mp-cart-item" data-cart-item="'+esc(item.key)+'" data-variant="'+item.variant_id+'">'+
      '<a class="mp-cart-item__image" tabindex="-1" aria-hidden="true" href="'+esc(item.url)+'">'+(item.image ? '<img src="'+esc(item.image)+'" width="72" height="88" alt="">' : '')+'</a>'+
      '<div class="mp-cart-item__body"><a class="mp-cart-item__title" href="'+esc(item.url)+'">'+title+'</a>'+variant+badge+priceHTML(item)+
      '<div class="mp-cart-item__controls"><div class="mp-cart-quantity">'+
      '<button type="button" data-cart-action="minus" aria-label="Riduci quantità di '+title+'">−</button><span>'+item.quantity+'</span>'+
      '<button type="button" data-cart-action="plus" aria-label="Aumenta quantità di '+title+'">+</button></div>'+
      '<button class="mp-cart-remove" type="button" data-cart-action="remove" aria-label="Rimuovi '+title+'">Rimuovi</button></div></div></article>';
  }
  function render(raw) {
    if (!raw || !Array.isArray(raw.items) || !Number.isFinite(raw.item_count) || !Number.isFinite(raw.total_price)) throw new Error('Risposta del carrello non valida.');
    window.STMNBtb?.clearDiscountError?.(raw);
    var cart = window.STMNBtb ? window.STMNBtb.cartView(raw) : raw;
    lastCart = cart; revision++;
    var focus = document.activeElement;
    var focusAction = focus?.getAttribute('data-cart-action'), focusVariant = focus?.closest('[data-variant]')?.dataset.variant;
    var scroll = $('mp-cart-scroll').scrollTop;
    count(cart);
    ['mp-cart-footer','mp-cart-top','mp-cart-promo','mp-cart-discount-section'].forEach(function (id) { if ($(id)) $(id).hidden = cart.item_count === 0; });
    if (!cart.item_count) {
      $('mp-cart-items').innerHTML = '<div class="mp-cart-empty"><p>Il tuo carrello è vuoto</p><a href="'+root+'collections/all">Continua lo shopping</a></div>';
    } else {
      $('mp-cart-items').innerHTML = cart.items.map(itemHTML).join('');
      var remaining = 8500 - cart.total_price;
      $('mp-cart-shipping-text').innerHTML = remaining > 0 ? 'Spendi <strong>'+money(remaining)+'</strong> in più per la <strong>spedizione gratuita</strong>' : 'Hai ottenuto la <strong>spedizione gratuita!</strong>';
      $('mp-cart-shipping-fill').style.width = Math.min(100,cart.total_price / 8500 * 100)+'%';
      $('mp-cart-shipping-fill').style.background = remaining > 0 ? '#333' : '#17563d';
      var original = cart.original_total_price || 0, saving = Math.max(0,original-cart.total_price) || cart.total_discount || 0;
      if (!original && saving) original = cart.total_price + saving;
      $('mp-cart-was-row').hidden = $('mp-cart-save-row').hidden = !(saving > 0 && original > cart.total_price);
      $('mp-cart-was').textContent = money(original); $('mp-cart-save').textContent = '− '+money(saving);
      $('mp-cart-subtotal').textContent = money(cart.total_price); $('mp-cart-checkout-total').textContent = '· '+money(cart.total_price);
      var input = $('mp-cart-discount-input');
      if (input) {
        var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
        input.dataset.applied = codes.map(function (c) { return c.code; }).join(',');
        $('mp-cart-discounts').textContent = codes.length ? 'Codice applicato: '+codes.map(function (c) { return c.code; }).join(', ') : '';
      }
    }
    window.STMNChalkLive?.render(cart);
    if (cart.item_count && !window.STMNChalkLive?.eligible(cart)) recommendations(cart.items[0].product_id, revision);
    document.dispatchEvent(new CustomEvent('stmn:cart-rendered',{detail:cart}));
    syncBusy();
    $('mp-cart-scroll').scrollTop = scroll;
    if (open && focusAction) {
      var replacement = Array.from(drawer.querySelectorAll('[data-variant]')).find(function (el) { return el.dataset.variant === focusVariant; });
      var target = replacement?.querySelector('[data-cart-action="'+focusAction+'"]');
      if (target && !target.disabled) target.focus({preventScroll:true});
      else $('mp-cart-close').focus({preventScroll:true});
    }
    return cart;
  }
  function recommendations(productId, renderRevision) {
    if (!productId) return;
    var token = ++recRevision;
    fetch(root+'recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit=8&intent=related')
      .then(function (r) { if (!r.ok) throw new Error('Recommendations unavailable'); return r.json(); })
      .then(function (data) {
        if (token !== recRevision || renderRevision !== revision || window.STMNChalkLive?.eligible(lastCart)) return;
        var products = (data.products || []).filter(function (p) { return p.available && !lastCart.items.some(function (i) { return i.product_id === p.id; }); });
        if (!products.length) return;
        $('mp-cart-recs-inline')?.remove();
        var html = '<section id="mp-cart-recs-inline"><h3>Completa il tuo allenamento</h3><div id="mp-cart-recs-track">';
        products.forEach(function (p) {
          var price = window.STMNBtb ? window.STMNBtb.html(p.price_min || p.price || 0,p) : money(p.price_min || p.price || 0);
          html += '<div class="mp-rec-card"><a class="mp-rec-card__img" tabindex="-1" aria-hidden="true" href="'+esc(p.url)+'">'+(p.featured_image ? '<img src="'+esc(p.featured_image)+'" alt="" loading="lazy">' : '')+'</a>'+
            '<div class="mp-rec-card__info"><a href="'+esc(p.url)+'" class="mp-rec-card__title">'+esc(p.title)+'</a><div class="mp-rec-card__price">'+price+'</div></div>'+
            '<button type="button" class="mp-rec-card__btn" data-rec-handle="'+esc(p.handle)+'" aria-label="Scegli '+esc(p.title)+'">+</button></div>';
        });
        $('mp-cart-items').insertAdjacentHTML('beforeend',html+'</div></section>');
      }).catch(function () { /* Optional recommendations never replace the cart. */ });
  }
  window.mpCartDrawerRefresh = function () {
    if (busy) { readAgain = true; return readTask || Promise.resolve(lastCart); }
    if (readTask) { readAgain = true; return readTask; }
    busy = true; syncBusy(); status('Aggiornamento del carrello…');
    if (!lastCart) $('mp-cart-items').innerHTML = '<p class="mp-cart-empty">Caricamento del carrello…</p>';
    readTask = transport.request(root+'cart.js').then(function (cart) {
      clearError(); busy = false; render(cart); status('Carrello aggiornato. '+cart.item_count+' articoli.');
      return cart;
    }).catch(function () {
      if (!lastCart) $('mp-cart-items').textContent = '';
      showError('Non riusciamo a caricare il carrello. Controlla la connessione e riprova.',true);
      status('Carrello non aggiornato.'); return null;
    }).finally(function () {
      busy = false; readTask = null; syncBusy();
      if (readAgain) { readAgain = false; window.mpCartDrawerRefresh(); }
    });
    return readTask;
  };
  window.mpCartDrawerUpdate = function (key, quantity) {
    if (busy || failed || transport.busy || !lastCart || !Number.isInteger(quantity) || quantity < 0) return Promise.resolve(null);
    if (!lastCart.items.some(function (i) { return i.key === key; })) return window.mpCartDrawerRefresh();
    busy = true; clearError(); syncBusy(); status('Aggiornamento della quantità…');
    return transport.request(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:quantity})})
      .then(function (cart) {
        return window.STMNBtb?.active ? window.STMNBtb.ensureDiscount().then(function (updated) { return updated || cart; }) : cart;
      }).then(function (cart) {
        busy = false; render(cart); status('Quantità aggiornata. '+cart.item_count+' articoli.'); return cart;
      }).catch(function (error) {
        // Shopify may cap a quantity even when it returns 422. Read the actual cart before enabling actions.
        return transport.request(root+'cart.js').then(function (cart) {
          busy = false; render(cart);
          showError(error.status === 422 ? 'La quantità richiesta non è disponibile. Il carrello mostra la disponibilità confermata.' : 'Non riusciamo a confermare la modifica. Controlla le quantità mostrate prima di riprovare.',false);
          return cart;
        }).catch(function () { showError('Non riusciamo a verificare la modifica. Controlla la connessione e premi Riprova prima di continuare.',true); return null; });
      }).finally(function () { busy = false; syncBusy(); if (readAgain) { readAgain = false; window.mpCartDrawerRefresh(); } });
  };
  window.mpCartApplyDiscount = function () {
    var input = $('mp-cart-discount-input'), msg = $('mp-cart-discount-msg');
    if (!input || busy || failed || transport.busy) return;
    var code = input.value.trim(), applied = input.dataset.applied || '';
    if (!code) { msg.textContent = 'Inserisci un codice sconto.'; input.focus(); return; }
    busy = true; syncBusy(); msg.textContent = 'Verifica del codice…';
    return transport.request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code})}).then(function (cart) {
      if ((cart.discount_codes || []).some(function (c) { return c.code.toLowerCase() === code.toLowerCase() && c.applicable; })) {
        busy = false; render(cart); msg.textContent = 'Codice sconto applicato.'; return;
      }
      return transport.request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:applied})}).then(function (restored) {
        busy = false; render(restored); msg.textContent = 'Codice sconto non valido o non applicabile a questo carrello.';
      });
    }).catch(function () { showError('Non riusciamo a verificare il codice sconto. Premi Riprova.',true); })
      .finally(function () { busy = false; syncBusy(); });
  };
  drawer.addEventListener('click',function (event) {
    var action = event.target.closest('[data-cart-action]');
    if (action && !action.disabled) {
      var item = lastCart?.items.find(function (i) { return i.key === action.closest('[data-cart-item]').dataset.cartItem; });
      if (item) window.mpCartDrawerUpdate(item.key, action.dataset.cartAction === 'remove' ? 0 : item.quantity+(action.dataset.cartAction === 'plus' ? 1 : -1));
    }
    var rec = event.target.closest('[data-rec-handle]');
    if (rec && !busy && !failed) window.mpCartDrawerClose(function () { if (window.openQuickAdd) window.openQuickAdd(rec.dataset.recHandle); else location.href = root+'products/'+rec.dataset.recHandle; });
  });
  // The transport's early capture listener also guards campaign checkout handlers.
  document.addEventListener('click',function (event) {
    if (event.target.closest('#mp-cart-checkout-btn') && (busy || failed || transport.busy)) { event.preventDefault(); event.stopImmediatePropagation(); status('Attendi l’aggiornamento del carrello prima di continuare.'); }
  },true);
  document.addEventListener('keydown',function (event) {
    if (!open) return;
    if (event.key === 'Escape') { event.preventDefault(); window.mpCartDrawerClose(); return; }
    if (event.key !== 'Tab') return;
    var all = focusables(), first = all[0], last = all[all.length-1];
    if (!first) { event.preventDefault(); drawer.focus(); return; }
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('focusin',function (event) { if (open && !drawer.contains(event.target)) $('mp-cart-close').focus({preventScroll:true}); });
  document.addEventListener('stmn:cart-busy',syncBusy);
  document.addEventListener('stmn:cart-changed',function () { window.mpCartDrawerRefresh(); });
  window.mpCartMoney = money;
})();
